import styled from 'styled-components';

export const Button = styled.button`
  display: inline-block;
  padding: 0;
  font-weight: 400;
  text-align: left;
  text-decoration: underline;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s;
  color: #4b286d;
`;

export const ButtonLink = styled.a`
  color: #4b286d;
`;

export const LockedLabel = styled.p`
  font-size: 14px;
  color: #71757b;
  font-weight: 500;
`;

export const ButtonBox=styled.div`
display: flex;
text-align: center;
justify-content: space-around;
gap: 1rem;
`